/**
 * @fileOverview 日期相关处理(2019-11-26)
 * @author nicywang <nicywang@tencent.com>
 * @module utils/date
 */
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(quarterOfYear);

const _MS_PER_DAY = 1000 * 60 * 60 * 24;
const _CUR_DAY = new Date();

export const formatDate = function (date, symbol) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join(symbol);
};

export const quarterDates = () => {
  const now = new Date();
  const quarter = Math.floor(now.getMonth() / 3);
  const firstDate = new Date(now.getFullYear(), quarter * 3, 1);
  const endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);
  const start = formatDate(firstDate, '-');
  const end = formatDate(endDate, '-');

  return [start, end];
};

export const dateDiffInDays = function (target, source) {
  const a = new Date(target);
  const b = new Date(source);
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};

/**
 * @description: 获取当前月份第一天0时
 */
export const getMonthFirstDay = () => {
  const year = dayjs().year();
  const month = dayjs().month();
  const date = `${year}-${month + 1}-01`;
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};

// 判断是否是日期格式并返回
export const isDate = (date) => {
  if (isNaN(date) && !isNaN(Date.parse(date))) {
    return  date;
  }
};

/**
 * 获取最近一个季度末的一天
 * @param {string | Dayjs} date 如
 * @param {string | Dayjs} minDate {} 若目标日期<minDate，则返回minDate
 * @return {string} 如 2020-10-25
 */
export const getQuarterFirstDay = (date, minDate = '') => {
  const target = dayjs(date).startOf('quarter');
  if (minDate) {
    const min = dayjs(minDate);
    return (min.isAfter(target) ? min : target).format('YYYY-MM-DD');
  }
  return target.format('YYYY-MM-DD');
};

/**
 * 默认文件导出
 */
export default {
  quarterDates,
  dateDiffInDays,
  isDate,
  getQuarterFirstDay,
};
